import { useInView } from "@/hooks/useInView";

export default function AnimatedBar({
  target,
  className = "",
  barClassName = "",
  delay = 0,
  duration = 1200,
}) {
  const { ref, inView } = useInView({ threshold: 0.35, once: true });
  return (
    <div ref={ref} className={`h-1 rounded-full bg-white/5 overflow-hidden ${className}`}>
      <div
        className={`h-full rounded-full bg-teal/70 ${barClassName}`}
        style={{
          width: inView ? target : "0%",
          transition: `width ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
        }}
      />
    </div>
  );
}
